(() => {
  if (customElements.get('txc-editorial-card')) return;
  class EditorialCard extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const data = this.querySelector('[data-txc-variants]');
      if (!data) return;
      this.ready = true;
      this.querySelectorAll('.txc-card__values:not([data-txc-colors])').forEach(group => {
        const buttons = [...group.querySelectorAll('[data-txc-option]')];
        if (buttons.length && buttons.every(button => /^\d+(?:[.,]\d+)?$/.test(button.dataset.value))) {
          buttons.sort((a,b) => Number(a.dataset.value.replace(',','.')) - Number(b.dataset.value.replace(',','.'))).forEach(button => group.appendChild(button));
        }
      });
      const palette = {'PRETO':'#202020','BRANCO':'#ffffff','OFF WHITE':'#eee9dd','VERDE MILITAR':'#59624a','VERDE':'#37724b','VERDE ESCURO':'#294637','VERDE CLARO':'#9eb49a','VERMELHO ESCURO':'#812c34','VERMELHO':'#b53838','CINZA CLARO':'#c8c8c8','CINZA':'#818181','MARROM ESCURO':'#533e32','MARROM':'#886047','KHAKI':'#b3a27d','BEGE':'#d7c6a4','AZUL':'#39618d','AZUL MARINHO':'#25364e','ROSA':'#d79eab','AMARELO':'#e6cf68','LARANJA':'#cd793f'};
      this.querySelectorAll('[data-txc-color]').forEach(button => {
        if (!button.style.getPropertyValue('--txc-swatch')) button.style.setProperty('--txc-swatch',palette[button.dataset.value.toUpperCase()] || '#b5ada1');
      });
      this.variants = JSON.parse(data.textContent);
      const input = this.querySelector('[data-product-form-variant]');
      this.variant = this.variants.find(v => String(v.id) === input.value) || this.variants.find(v => v.available) || this.variants[0];
      this.addEventListener('click', event => {
        const more = event.target.closest('[data-txc-more]');
        if (more) {
          const expanded = more.getAttribute('aria-expanded') !== 'true';
          more.setAttribute('aria-expanded',String(expanded));
          more.textContent = expanded ? '−' : '+' + (more.parentElement.querySelectorAll('[data-txc-color]').length - 4);
          more.setAttribute('aria-label',expanded ? 'Mostrar menos cores' : 'Mostrar todas as cores');
          this.update();
          return;
        }
        const button = event.target.closest('[data-txc-option]');
        if (!button || button.disabled || this.querySelector('.product-form__btn.loading')) return;
        const index = Number(button.dataset.index);
        const options = [...this.variant.options];
        options[index] = button.dataset.value;
        this.variant = this.variants.find(v => v.available && v.options.every((o,i) => o === options[i]))
          || this.variants.find(v => v.available && v.options.every((o,i) => i > index || o === options[i]));
        this.update();
      });
      this.update();
    }
    update() {
      const v = this.variant;
      if (!v) return;
      this.querySelector('[data-product-form-variant]').value = v.id;
      this.querySelector('[data-txc-price]').textContent = v.money;
      const compare = this.querySelector('[data-txc-compare]');
      compare.textContent = v.compare_money;
      compare.hidden = !(v.compare > v.price);
      const discount = this.querySelector('[data-txc-discount]');
      discount.textContent = v.compare > v.price ? Math.round((v.compare-v.price)*100/v.compare) + '% OFF' : '';
      discount.hidden = !(v.compare > v.price);
      this.querySelectorAll('[data-txc-option]').forEach(button => {
        const index = Number(button.dataset.index);
        const selected = v.options[index] === button.dataset.value;
        button.setAttribute('aria-pressed', String(selected));
        button.disabled = !this.variants.some(candidate => candidate.available && candidate.options[index] === button.dataset.value && candidate.options.every((o,i) => i >= index || o === v.options[i]));
      });
      this.querySelectorAll('[data-txc-colors]').forEach(group => {
        const colors = [...group.querySelectorAll('[data-txc-color]')];
        const more = group.querySelector('[data-txc-more]');
        const selected = colors.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        const expanded = more && more.getAttribute('aria-expanded') === 'true';
        colors.forEach((button,index) => { button.hidden = !expanded && !(index < (selected >= 4 ? 3 : 4) || index === selected); });
      });
      this.querySelectorAll('[data-txc-product-link]').forEach(link => { const url = new URL(link.href); url.searchParams.set('variant',v.id); link.href = url.href; });
      const image = this.querySelector('[data-txc-image]');
      if (image && v.image && image.getAttribute('src') !== v.image) { image.removeAttribute('srcset'); image.src = v.image; }
      const submit = this.querySelector('button[type="submit"]');
      submit.disabled = !v.available;
      submit.querySelector('[data-button-text]').textContent = v.available ? 'Adicionar à sacola' : 'Esgotado';
      const status = this.querySelector('[data-txc-status]');
      status.textContent = v.available ? v.options.join(' / ') : 'Indisponível';
    }
  }
  customElements.define('txc-editorial-card',EditorialCard);
})();
